'use strict';

var d3 = require('d3');
var TodayLine = function TodayLine(d3Helper, momentService, hepService) {
  return function () {
    var params, scales;
    var todayLine = function todayLine(container) {
      var rangeExtent = scales.yScale.rangeExtent ? scales.yScale.rangeExtent() : scales.yScale.range();
      var middleOfGroup = params.isSparse ? params.xDataSize / 2 : scales.xScale.rangeBand() / 2;
      var todayMoment = momentService.systemNow(momentService.FIELD.PRICING_SUMMARY_OPTIMIZATION_DATE);
      var runFrequency = hepService.getSimpleHepProperty('DYNAMIC_PRICING_RECOM_FREQUENCY');
      var y1 = rangeExtent[0];
      var y2 = rangeExtent[1];
      var x1, x2;
      x1 = x2 = middleOfGroup;
      var latestRunNumber = 1;
      var createTodayLine = function createTodayLine(todayLineGroup) {
        todayLineGroup.append('line').attr({
          'class': 'today-line',
          'y1': y1,
          'y2': y2 - 10,
          'x1': x1,
          'x2': x2
        });
        todayLineGroup.append('text').text(runFrequency > 1 ? 'Latest' : 'Today').attr({
          'x': x1 - 18,
          'y': -15
        });
      };
      var constructTodayLineGroup = function constructTodayLineGroup(stackGroupSel) {
        //remove old todayLine-group
        container.select('g.todayLine-group').remove();
        var todayLineGroup = d3Helper.createGroupElement(stackGroupSel, 'todayLine-group', true);
        createTodayLine(todayLineGroup);
      };
      var groups = container.select('.groups').selectAll('.stack');
      groups.each(function (d) {
        var stackGroupSel = d3.select(this);
        if (d.snapshotDate.isSame(todayMoment, 'day')) {
          if (runFrequency === 1) {
            constructTodayLineGroup(stackGroupSel);
          } else {
            var runNumber = parseInt(d.runNumber.slice(8, 9));
            if (runNumber >= latestRunNumber) {
              latestRunNumber = runNumber;
              constructTodayLineGroup(stackGroupSel);
            }
          }
        }
      });
    };
    todayLine.params = function (value) {
      params = value;
      return todayLine;
    };
    todayLine.scales = function (value) {
      scales = value;
      return todayLine;
    };
    return todayLine;
  };
};
TodayLine.$inject = ['d3Helper', 'MomentService', 'HepService'];
module.exports = TodayLine;